function CommunityIllustration() {
  const posts = [
    {
      user: 'María T.',
      avatar: 'MT',
      time: 'hace 2 h',
      text: 'Cerré mi posición en NVDA con +18%. Setup de breakout en 4H.',
      likes: 24,
      ticker: 'NVDA',
    },
    {
      user: 'Carlos R.',
      avatar: 'CR',
      time: 'hace 5 h',
      text: 'Iron condor en SPY esta semana. Comparto el plan en mi bitácora.',
      likes: 12,
      ticker: 'SPY',
    },
  ];

  return (
    <div className="illus illus--community" aria-hidden="true">
      <div className="illus__window">
        <div className="illus__titlebar">
          <span />
          <span />
          <span />
          <span className="illus__titlebar-text">Feed · Comunidad</span>
        </div>
        <div className="illus-feed">
          {posts.map((post) => (
            <article key={post.user} className="illus-post">
              <div className="illus-post__header">
                <div className="illus-post__avatar">{post.avatar}</div>
                <div>
                  <strong>{post.user}</strong>
                  <span className="illus-post__time">{post.time}</span>
                </div>
                <span className="illus-post__ticker">{post.ticker}</span>
              </div>
              <p className="illus-post__text">{post.text}</p>
              <div className="illus-post__footer">
                <span>♥ {post.likes}</span>
                <span>Comentar</span>
              </div>
            </article>
          ))}
        </div>
        <div className="illus-privacy">
          <span className="illus-privacy__icon">🔒</span>
          <span>Tu bitácora privada sigue oculta</span>
        </div>
      </div>
    </div>
  );
}

export default CommunityIllustration;
